import { api } from "@/lib/api"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

export function AIChangelogsChart() {
	const query = api.analytics.aiChangelogsChart.useQuery({})

	return (
		<WorkspaceStackedBarChart
			title="AI Changelogs"
			data={query.data}
			isLoading={query.isLoading}
		/>
	)
}
